export default __webpack_public_path__ + "static/media/old-gala.5f10596e.jpg";